import script from "./BaseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseView.vue?vue&type=script&lang=ts&setup=true"

import "./BaseView.vue?vue&type=style&index=0&id=2ce5ed0a&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce5ed0a"]])

export default __exports__